import { render, staticRenderFns } from "./addView.vue?vue&type=template&id=196561bc&scoped=true"
import script from "./addView.vue?vue&type=script&lang=js"
export * from "./addView.vue?vue&type=script&lang=js"
import style0 from "./addView.vue?vue&type=style&index=0&id=196561bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196561bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('196561bc')) {
      api.createRecord('196561bc', component.options)
    } else {
      api.reload('196561bc', component.options)
    }
    module.hot.accept("./addView.vue?vue&type=template&id=196561bc&scoped=true", function () {
      api.rerender('196561bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/baseInfo/adsManage/addView.vue"
export default component.exports